const T = {
  background: "white",
  active: "primary",
  hover: "default",
  text: "secondary"
}, s = (_) => _.sort((n, E) => {
  const o = (t) => t.position === "top" || t.position === void 0 ? 1 : t.position === "bottom" ? 3 : 2;
  return o(n) - o(E);
}), D = 40, O = 48, I = 8, r = 37, c = 32, A = 24, H = 24, e = 220, i = 80, G = 0.2, N = 184;
export {
  i as COLLAPSED_SIDEBAR_WIDTH,
  G as DEFAULT_ANIMATION_SECOND_TIME,
  T as DEFAULT_COLORS,
  N as DEFAULT_MAX_HEIGHT_SHOW_MORE_MENU,
  e as EXTENDED_SIDEBAR_WIDTH,
  H as EXTRA_PADDING_BOTTOM_UL,
  D as LOGO_HEIGHT,
  c as PADDING_BETWEEN_UL_LOGO,
  A as PADDING_BOTTOM_HEIGHT,
  r as PADDING_TOP_HEIGHT,
  I as PRODUCT_ICON_GAP_HEIGHT,
  O as PRODUCT_ICON_HEIGHT,
  s as sortRoutes
};
